
import { mapActions, mapGetters } from 'vuex';
import ExternalLink from './ExternalLink.vue';
import InternalLink from './InternalLink.vue';
import NudgeContents from '../common/NudgeContents.vue';

export default {
  components: {
    ExternalLink,
    InternalLink,
    NudgeContents,
  },

  props: {
    menu: {
      type: Object,
      default: () => {},
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      demoConversation: {
        name: 'the product',
        id: 'not-a-real-conversation',
      },
    };
  },

  computed: {
    ...mapGetters('chatbotStore', ['getTriggeredConversation', 'currentAmp', 'getAmpById', 'currentConversationId']),

    ampName() {
      const amp = !this.previewMode ? this.getAmpById(this.getTriggeredConversation?.ampId) : this.currentAmp;

      return amp.name || '';
    },

    conversation() {
      return !this.previewMode ? this.getTriggeredConversation : this.demoConversation;
    },

    externalLinks() {
      return Object.values(this.menu?.external || {}).sort((a, b) => a.sortIndex - b.sortIndex);
    },

    internalLinks() {
      return Object.values(this.menu?.internal || {}).sort((a, b) => a.sortIndex - b.sortIndex);
    },

    internalSectionTitle() {
      return this.menu?.internalSectionTitle;
    },

    externalSectionTitle() {
      return this.menu?.externalSectionTitle;
    },
  },

  methods: {
    ...mapActions('chatbotStore', ['goToAmp', 'setAmpSetupOptions', 'setTriggeredConversation']),

    onConversationRedirect() {
      if (this.previewMode) {
        return;
      }

      const { ampId, id: conversationId } = this.conversation || {};
      const changeConversationEvent = {
        conversationId,
        prevConversationId: this.currentConversationId || '',
        changeEvent: 'NUDGE',
      };

      if (this.currentAmpId !== ampId) {
        this.setAmpSetupOptions({ conversationId, ampId });
        this.goToAmp(ampId);
      } else {
        this.$chatbotService.runConversation(conversationId);
      }

      this.setTriggeredConversation(null);
      this.closeMenu();
      this.$tracking?.sendResponseEvent('conversationChange', changeConversationEvent);
    },

    onConversationChange(conversationId) {
      if (this.previewMode) {
        return;
      }

      const conversationChangeEvent = {
        conversationId,
        prevConversationId: this.currentConversationId || '',
        changeEvent: 'MENU',
      };

      this.$chatbotService.runConversation(conversationId);
      this.$tracking?.sendResponseEvent('conversationChange', conversationChangeEvent);
      this.closeMenu();
    },

    handleLink(link) {
      if (this.previewMode) {
        return;
      }

      window.open(link, '_blank');
    },

    closeMenu() {
      if (this.previewMode) {
        return;
      }

      this.$emit('close');
    },
  },
};
